import React from "react";
import "./css/footer.css";

function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-section">
          <h4>روابط مهمة</h4>
          <ul className="footer-links">
            <li><a className="yadu" href="/about">من نحن</a></li>
            <li><a className="yadu" href="/services">الخدمات</a></li>
            <li><a className="yadu" href="/contact">تواصل معنا</a></li>
            <li><a className="yadu" href="/blog">المدونة</a></li>
          </ul>
        </div>

        <div className="footer-section" id="center">
          <h4>تواصل معنا</h4>
          <p>123 شارع النمو, تونس</p>
          <p>الهاتف: +216 12 345 678</p>
          <p>البريد الإلكتروني: info@ghadawebsite.com</p>
        </div>

        <div className="footer-section footer-social">
          <h4>تابعونا</h4>
          <div className="social-icons">
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-twitter"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} firas lweti. جميع الحقوق محفوظة.</p>
      </div>
    </footer>
  );
}

export default Footer;
